/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PPConfigType {
    None = 0,
    DynaTouch = 1,
    InvoiceCloudV1 = 2,
    InvoiceCloudV2 = 3,
    GrantStreet = 4,
    Fiserv = 5,
    Paymentus = 6,
    PayGo = 7,
    MyUsage = 8,
}
